import React, { useState, useEffect } from 'react';
import clsx from "clsx";
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  makeStyles,
  CardContent,
  Grid,
  TextField,
  Divider,
} from '@material-ui/core';


import {
  MAX_LENGTH
} from "common/constants";


import firebase from '../../Firebase';
import { getDatabase, ref, onValue, get, child } from 'firebase/database';


import AllCHGRStatus from "./allChgrStatus";
import LCStatus from "./lcStatus";
import CHGRStatusTable from "./chgrStatusTable";
// import CHGRStatus from "./chgrStatus_notuse";
import i18n from 'i18n/i18n';  // i18n 객체 직접 import
import 'intl-pluralrules';



const SummaryAllCHGR = props => {
  const { className, ...rest } = props;
  const classes = useStyles();


  const [simuCurrentTime, setSimuCurrentTime ] = useState('');

  const database = getDatabase();
  const dbRef = ref(database);

  const makeSampleData = () => {

    onValue(child(dbRef, 'simu/summary/lc'), (snapshot) => {
      setSimuCurrentTime(snapshot.val().simu_current_time);
    });
  }

  useEffect(() => {
    makeSampleData();
  }, []);


  return (
    <div>
      <Card className={clsx(classes.root, className)} >

        <CardContent>
          <Grid container direction="row" justifyContent="center" spacing={0}>
            <Grid item>
              <Typography className={classes.title} color="textSecondary" gutterBottom variant="h2" align='center'>
              {i18n.t("evse_status")}
              </Typography>
            </Grid>
          </Grid>

          <Grid item lg={12} md={12} xs={12}><AllCHGRStatus /></Grid>
          <Divider style={{marginBlock:'10px'}}/>

          {/* <Grid item lg={12} md={12} xs={12}><LCStatus /></Grid>
          <Divider style={{marginBlock:'10px'}}/> */}


          <Grid container direction="row" justifyContent="flex-end" spacing={0}>
            <Grid item >
              <Typography color="textSecondary" gutterBottom variant="caption" align='center'>
              time on the simulation : {simuCurrentTime}
              </Typography>
            </Grid>
          </Grid>


          <Grid item lg={12} md={12} xs={12} style={{paddingInline:'0.4em'}}>
            <CHGRStatusTable />
          </Grid>
        </CardContent>
      </Card>
    </div>
  )
}


export default SummaryAllCHGR;



const useStyles = makeStyles((theme) => ({

  root: {
  },

  chartContainer: {
    // //360px 이상
    // ['@media (min-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 160,
    // },
    // //360px 이하
    // ['@media (max-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 120,
    // },
    position: 'relative'
  },



  title: {
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  differenceValue: {
    marginRight: theme.spacing(1),
  },
  difference: {
    // marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    marginLeft: theme.spacing(1),
  },
  labelbox: {
    margin: theme.spacing(2),
  },
  current: {
    marginTop: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    // color: theme.palette.secondary.contrastText,
    // backgroundColor: theme.palette.secondary.main,
  },
  green: {
    color: theme.palette.success.light,
    fontWeight: 600,
  },
  red: {
    color: theme.palette.error.light,
    // color: colors.red[400],
    fontWeight: 600,
  }
}));
